exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app[data-v-1e3668b8]{width:100%;max-width:450px}@media (min-width:768px){.app[data-v-1e3668b8]{width:450px}}", ""]);

// exports
